<div class="view-mode-buttons">
  <button (click)="setViewMode('timeline')" [class.active]="viewMode === 'timeline'">Timeline</button>
  <button (click)="setViewMode('table')" [class.active]="viewMode === 'table'">Table</button>
</div>

<!-- Timeline -->
<div *ngIf="viewMode === 'timeline'" class="timeline-container-vertical">
  <div class="timeline-line">
    <span class="timeline-label top">Newest</span>
    <span class="timeline-label bottom">Oldest</span>
  </div>

  <div *ngFor="let item of userTrackerConsentsSorted" class="timeline-item"
    [ngClass]="{'optIn': item.Action === 'OptIn', 'optOut': item.Action === 'OptOut'}">

    <!-- <div class="timeline-content">
      <div class="timeline-value">{{ item.Value }}</div>
      <div class="timeline-app">{{ item.App }} {{item.Section}}</div>
      <div class="timeline-date">{{ item.DateTime | date:'dd/MM/yyyy HH:mm:ss' }}</div>
    </div> -->

    <div class="timeline-content">

      <ng-container *ngIf="item.Action === 'OptOut'">
        <span class="channel-icon left material-icons">
          {{ getChannelIcon(item.Channel) }}
        </span>
      </ng-container>

      <div class="timeline-text">
        <div class="timeline-value">{{ item.Value }}</div>
        <div class="timeline-app">{{ item.App }} {{item.Section}}</div>
        <div class="timeline-date">{{ item.DateTime | date:'dd/MM/yyyy HH:mm:ss' }}</div>
      </div>

      <ng-container *ngIf="item.Action === 'OptIn'">
        <span class="channel-icon right material-icons">
          {{ getChannelIcon(item.Channel) }}
        </span>
      </ng-container>

    </div>

    <div class="timeline-icon">
      <ng-container *ngIf="item.Action === 'OptIn'; else optOutIcon">

        ✓
      </ng-container>
      <ng-template #optOutIcon>

        ✕
      </ng-template>
    </div>

  </div>
</div>

<!-- Table -->
<div *ngIf="viewMode === 'table'" class="table-view">
  <table>
    <thead>
      <tr>
        <th>Type Detail</th>
        <th>In/Out</th>
        <th>Actioned By</th>
        <th>Date</th>
        <th>More</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of userTrackerConsentsSorted"
        [ngClass]="{red: item.Action === 'OptOut', green: item.Action === 'OptIn'}">
        <td class="value-container">
          <ng-container *ngIf="item.Action === 'OptOut'">
            <span class="channel-icon red material-icons">
              {{ getChannelIcon(item.Channel) }}
            </span>
          </ng-container>
          
          <ng-container *ngIf="item.Action === 'OptIn'">
            <span class="channel-icon green right material-icons">
              {{ getChannelIcon(item.Channel) }}
            </span>
          </ng-container>
          {{ item.Value }}
        </td>
        <td class="center">

          <ng-container *ngIf="item.Action === 'OptIn'; else optOutIcon">
            ✓
          </ng-container>
          <ng-template #optOutIcon>
            ✕
          </ng-template>


        </td>
        <td>{{ item.App }} / {{item.ByCustomer ? 'Client' : 'Agent'}}</td>
        <td>{{ item.DateTime | date:'dd/MM/yyyy HH:mm:ss' }}</td>
        <td class="center">
          <button mat-icon-button color="primary" (click)="openDetails(item)">
            <mat-icon>search</mat-icon>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>